import { Translatable } from '@app/types/translatable.type';

export const LeaveOfAbsenceTypesDisplayOptions: { [key: string]: Translatable } = {
    'Compassionate care / Family caregiver': 'employees.leaveOfAbsence.compassionate',
    'Illness or injury': 'employees.leaveOfAbsence.illness',
    Maternity: 'employees.leaveOfAbsence.maternity',
    Parental: 'employees.leaveOfAbsence.parental',
    'Leave of absence': 'employees.leaveOfAbsence.leaveOfAbsence',
};
